import React from "react";
import "./promo.scss";
import penawaran from "../../../media/Hardsell_KBP.webp";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const Penawaran = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285720445400&text=Halo%20Rizki,%20Saya%20bbisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Kota%20Baru%20Parahyangan%20(Promo)%20https://kbp-kotabaruparahyangan.id//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="judulpromo">
      <div id="promo" className="judul">
        <h1>OUR PROMO</h1>
      </div>
      <div id="promo" className=" containerPenawaran">
        <div className="containercontent">
          <div className="pointpenawaran">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(72, 72, 72)"}}>
                &nbsp;&nbsp;Free PPN 100%
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(72, 72, 72)"}}>
                &nbsp;&nbsp;Soft DP
              </span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(72, 72, 72)"}}>
                &nbsp;&nbsp;Free Smart Door Lock
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(72, 72, 72)"}}>
                &nbsp;&nbsp;Free Smarthome System
              </span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(72, 72, 72)"}}>
                &nbsp;&nbsp;Free Mobil BYD Seal*
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(72, 72, 72)"}}>
                &nbsp;&nbsp;Free Mobil Jaecoo*
              </span>
            </div>
          </div>
          <div className="disclaimer">*Disclaimer</div>
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            Learn More
          </button>
        </div>
        <div className="containergambar">
          <img className="penawarangambar" src={penawaran} alt={penawaran} />
        </div>
      </div>
    </div>
  );
};

export default Penawaran;
